import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-x-large);
	align-items: center;

	.user {
		flex: 1;
	}
`;
